import React from 'react';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import ItemLink from 'components/Layouts/Admin/Dashboard/Navigation/ItemLink';
import BackLink from 'components/Layouts/Form/Header/shared/BackLink';
import MainHeader from 'components/Layouts/shared/MainHeader';
import { usePageContext } from 'components/Pages/Admin/PageTypes/shared/context';
import { STEPS, STEP_NAMES, STEP_PATHS } from 'components/Pages/Admin/PageTypes/shared/context/map';
import { useAccountPath } from 'hooks/useAccountPath';
import { getLandingLinkName, pageDataSelector } from 'store/page/selectors';
import { appHasChangesSelector } from 'store/unsavedChanges/selectors';

import baseStyles from '../index.module.css';

function PageHeader() {
  const {
    steps,
    backButton: { link, text, isSSR = false },
  } = usePageContext();
  const getPath = useAccountPath();
  const { pageId } = useParams();
  const page = useSelector(pageDataSelector);
  const landingLinkName = useSelector(getLandingLinkName);
  const doesPageHaveChanges = useSelector(appHasChangesSelector);
  const indexOfLastAvailableStep = page.lastAvailableStep ? steps.indexOf(page.lastAvailableStep) : 0;

  return (
    <MainHeader
      backLink={
        <BackLink isSSR={isSSR} href={link}>
          {text}
        </BackLink>
      }
      links={steps.map((step, index, array) => {
        const isLastElement = index === array.length - 1;
        // probably need to refactor landingLinkName
        const name = step === STEPS.PAGE ? landingLinkName : STEP_NAMES[step];

        return (
          <ItemLink
            key={name}
            href={getPath(STEP_PATHS[step], { pageId })}
            noMargin
            withDots={!isLastElement}
            className={baseStyles.link}
            linkClassName={baseStyles.tab}
            disabled={doesPageHaveChanges || index > indexOfLastAvailableStep}
          >
            {name}
          </ItemLink>
        );
      })}
    />
  );
}

export default PageHeader;
